import React, { FC, useState, useCallback, useMemo, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { RSModal } from 'src/reservation-page/modality/RSModal';
import { RSDetailHeaderButtonAnchor } from 'src/reservation-page/detail-header/RSDetailHeaderButtonAnchor';

import { OptionsSelectModalContent } from '../OptionsSelectModalContent';
import { buildUrl } from 'src/utils/request-url';

export interface OptionsSelectModalWithLoginProps {
  isOpen: boolean;
  onRequireClosing: () => void;
  merchantPublicId: string;
  resourcePublicId: string;
  courseCanonicalId: number;
  href: string;
}

export const OptionsSelectModalWithLogin: FC<
  OptionsSelectModalWithLoginProps
> = ({
  isOpen,
  onRequireClosing,
  merchantPublicId,
  resourcePublicId,
  courseCanonicalId,
  href,
}) => {
  const intl = useIntl();

  const [optionIds, setOptionIds] = useState<number[]>([]);
  const onOptionIdsChange = useCallback((optionIds: number[]) => {
    setOptionIds(optionIds);
  }, []);

  const signinUrlWithRedirect = useMemo(() => {
    const url = new URL(`https://example.com${href}`);

    for (const optionId of optionIds) {
      url.searchParams.append('optionIds[]', optionId.toString());
    }
    return buildUrl(
      `/signin/user?return_to=${encodeURIComponent(
        `${url.pathname}?${url.searchParams.toString()}`,
      )}`,
    );
  }, [href, optionIds]);

  useEffect(() => {
    if (isOpen) return;

    setOptionIds([]);
  }, [isOpen]);

  return (
    <RSModal
      title={intl.formatMessage({
        defaultMessage: 'オプション選択',
        id: 'Lro511',
        description:
          'src/templates/merchants/resources/DetailTemplate/components/Appointment/OptionsSelectModal/index.tsx',
      })}
      isOpen={isOpen}
      closeText={intl.formatMessage({
        defaultMessage: '閉じる',
        id: 'BhmN6i',
        description:
          'src/templates/merchants/resources/DetailTemplate/components/Appointment/OptionsSelectModal/index.tsx',
      })}
      onRequireClosing={onRequireClosing}
      rightButton={
        <RSDetailHeaderButtonAnchor variant="ok" href={signinUrlWithRedirect}>
          {intl.formatMessage({
            defaultMessage: '次へ',
            id: 'WN3cDb',
            description:
              'src/templates/merchants/resources/DetailTemplate/components/Appointment/OptionsSelectModal/index.tsx',
          })}
        </RSDetailHeaderButtonAnchor>
      }
    >
      <div className="pc:p-4 p-2.5">
        <OptionsSelectModalContent
          merchantPublicId={merchantPublicId}
          resourcePublicId={resourcePublicId}
          courseCanonicalId={courseCanonicalId}
          optionIds={optionIds}
          onOptionIdsChange={onOptionIdsChange}
        />
      </div>
    </RSModal>
  );
};
